import { TutorialAdmin as Admin } from './TutorialAdmin';
import { TutorialLearning as Learning } from './TutorialLearning';

export const Tutorial = {
  Admin,
  Learning,
};
